import styled from 'styled-components';
import { useState } from 'react';
import {
  CommercialAreaData,
  ExtractionAreaData,
  FilterType,
  GreenAreaData,
  IndustrialAreaData,
  ManagementAreaData,
  ResidentialAreaData,
  UseAreaData,
  UseDistrictData,
} from '../../../search/filter/SampleData';

interface Props {
  filters: any;
  setFilters: (filters: any) => void;
  nonBorder?: boolean;
}

const UseArea = ({ filters, setFilters, nonBorder }: Props) => {
  const TABS = [
    '도시지역',
    '관리지역',
    '기타지역',
    '용도지구',
    '용도구역',
  ] as const;

  type TabType = (typeof TABS)[number];

  const [activeTab, setActiveTab] = useState<TabType>('도시지역');

  const allSelected1 = ResidentialAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected2 = CommercialAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected3 = IndustrialAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected4 = GreenAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected5 = ManagementAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected6 = ExtractionAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected7 = UseDistrictData.every((item) =>
    filters.useArea.includes(item.name),
  );
  const allSelected8 = UseAreaData.every((item) =>
    filters.useArea.includes(item.name),
  );

  const toggleFilter = (value: string) => {
    setFilters({
      ...filters,

      useArea: filters.useArea.includes(value)
        ? filters.useArea.filter((v: any) => v !== value)
        : [...filters.useArea, value],
    });
  };
  const toggleAllSelect = (
    state: boolean,
    data: { name: string; value: string }[],
  ) => {
    if (state) {
      setFilters({
        ...filters,
        useArea: filters.useArea.filter(
          (name: string) => !data.some((item) => item.name === name),
        ),
      });
    } else {
      setFilters({
        ...filters,

        useArea: Array.from(
          new Set([...filters.useArea, ...data.map((item) => item.name)]),
        ),
      });
    }
  };

  return (
    <AllOptionBox>
      <TabMenu>
        {TABS.map((tab) => (
          <TabButton
            key={tab}
            active={activeTab === tab}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </TabButton>
        ))}
      </TabMenu>
      <AllOptionBoxContent>
        {activeTab === '도시지역' && (
          <BlockContainer>
            <Block>
              <BlockTitle>주거지역</BlockTitle>
              <BlockContent>
                <OptionItem
                  style={{
                    width: '100%',
                  }}
                  onClick={() =>
                    toggleAllSelect(allSelected1, ResidentialAreaData)
                  }
                >
                  <img
                    src={`/assets/images/check/${allSelected1 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>주거지역 전체</span>
                </OptionItem>
                {ResidentialAreaData.map((item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ))}
              </BlockContent>
            </Block>
            <Stick></Stick>
            <Block>
              <BlockTitle>상업지역</BlockTitle>
              <BlockContent>
                <OptionItem
                  style={{
                    width: '100%',
                  }}
                  onClick={() =>
                    toggleAllSelect(allSelected2, CommercialAreaData)
                  }
                >
                  <img
                    src={`/assets/images/check/${allSelected2 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>상업지역 전체</span>
                </OptionItem>
                {CommercialAreaData.map((item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ))}
              </BlockContent>
            </Block>
            <Stick></Stick>
            <Block>
              <BlockTitle>공업지역</BlockTitle>
              <BlockContent>
                <OptionItem
                  style={{
                    width: '100%',
                  }}
                  onClick={() =>
                    toggleAllSelect(allSelected3, IndustrialAreaData)
                  }
                >
                  <img
                    src={`/assets/images/check/${allSelected3 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>공업지역 전체</span>
                </OptionItem>
                {IndustrialAreaData.map((item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ))}
              </BlockContent>
            </Block>
            <Block>
              <BlockTitle>녹지지역</BlockTitle>
              <BlockContent>
                <OptionItem
                  style={{
                    width: '100%',
                  }}
                  onClick={() => toggleAllSelect(allSelected4, GreenAreaData)}
                >
                  <img
                    src={`/assets/images/check/${allSelected4 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>녹지지역 전체</span>
                </OptionItem>
                {GreenAreaData.map((item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ))}
              </BlockContent>
            </Block>
          </BlockContainer>
        )}
        {activeTab === '관리지역' && (
          <BlockContainer>
            <Block>
              <BlockContent>
                <OptionItem
                  style={{
                    width: '100%',
                  }}
                  onClick={() =>
                    toggleAllSelect(allSelected5, ManagementAreaData)
                  }
                >
                  <img
                    src={`/assets/images/check/${allSelected5 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>관리지역 전체</span>
                </OptionItem>
                {ManagementAreaData.map((item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ))}
              </BlockContent>
            </Block>
          </BlockContainer>
        )}
        {activeTab === '기타지역' && (
          <BlockContainer>
            <Block>
              <BlockContent>
                <OptionItem
                  style={{
                    width: '100%',
                  }}
                  onClick={() =>
                    toggleAllSelect(allSelected6, ExtractionAreaData)
                  }
                >
                  <img
                    src={`/assets/images/check/${allSelected6 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>관리지역 전체</span>
                </OptionItem>
                {ExtractionAreaData.map((item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ))}
              </BlockContent>
            </Block>
          </BlockContainer>
        )}
        {activeTab === '용도지구' && (
          <BlockContainer>
            <Block>
              <BlockContent>
                <OptionItem
                  style={{
                    width: '100%',
                  }}
                  onClick={() => toggleAllSelect(allSelected7, UseDistrictData)}
                >
                  <img
                    src={`/assets/images/check/${allSelected7 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>용도지구 전체</span>
                </OptionItem>
                {UseDistrictData.map((item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ))}
              </BlockContent>
            </Block>
          </BlockContainer>
        )}
        {activeTab === '용도구역' && (
          <BlockContainer style={{ borderBottom: 'none' }}>
            <Block>
              <BlockContent>
                <OptionItem
                  style={{
                    width: '100%',
                  }}
                  onClick={() => toggleAllSelect(allSelected8, UseAreaData)}
                >
                  <img
                    src={`/assets/images/check/${allSelected8 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                    alt="Check"
                  />
                  <span>용도구역 전체</span>
                </OptionItem>
                {UseAreaData.map((item: any, index: number) => (
                  <OptionItem
                    key={index}
                    onClick={() => toggleFilter(item.name)}
                  >
                    <img
                      src={`/assets/images/check/${filters.useArea.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                      alt="Check"
                    />
                    <span>{item.name}</span>
                  </OptionItem>
                ))}
              </BlockContent>
            </Block>
          </BlockContainer>
        )}
      </AllOptionBoxContent>
    </AllOptionBox>
  );
};
export default UseArea;

const AllOptionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff;
`;
const AllOptionBoxContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const BlockContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: #171e26;
  padding: 24px;
  border-bottom: 1px solid #e8e9ea;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: rgba(23, 30, 38, 0.78);
`;
const BlockContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const OptionItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  gap: 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  white-space: nowrap;
  padding: 8px 0;
`;

const BlockTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  color: #222;
`;

const Stick = styled.div`
  background: rgba(112, 115, 124, 0.16);
  height: 1px;
  widht: 100%;
`;

const TabMenu = styled.div`
  display: flex;
  width: 100%;
  overflow-x: scroll;
  border-bottom: 1px solid #e1e2e4;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const TabButton = styled.div<{ active: boolean }>`
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  font-style: normal;
  white-space: nowrap;
  font-weight: ${(props) => (props.active ? '700' : '500')};
  color: ${(props) => (props.active ? '#222' : '#989BA2')};
  border-bottom: ${(props) => (props.active ? '2px solid #222' : 'none')};
`;
